// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchForm_input__1z0Qt","inputWrapper":"SearchForm_inputWrapper__33ZfS","searchIcon":"SearchForm_searchIcon__2KWP9","clearIcon":"SearchForm_clearIcon__3FOLp"};